import serviceSettingsAllComponent from './service_settings.all.component'

let serviceSettingsAllModule = angular.module('serviceSettingsAll', [])

    .component('serviceSettingsAll', serviceSettingsAllComponent)

    .name;

export default serviceSettingsAllModule;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/all/index.js